import React, {useEffect} from "react";
import {withRouter} from "react-router-dom";
import {apiPost} from "../api";
import snackbar from "../snackbar";
import {useCurrentState} from "../globalState";

function LogoutPage(props) {

    let [user, setUser] = useCurrentState("user");

    useEffect(() => {
        apiPost("logout").then((res) => {
            snackbar("Logged out!");
            setUser(res.data);
            props.history.push("/");
        });
    }, []);
    return <div>Logging you out...</div>
}

LogoutPage = withRouter(LogoutPage);

export default LogoutPage;